<div class="accordion" id="accordionValidacaoFoto">
  <!-- Resumo geral quando todos estiverem com sucesso -->
  <app-status-processing
    *ngIf="mostrarResumoGeral"
    titulo="Cadastro enviado para MedSenior!"
    subtitulo="aguarde a validação da Declaração de Saúde."></app-status-processing>

  <!-- Acordeões - só mostra se o resumo geral não estiver sendo mostrado -->
  <ng-container *ngIf="!mostrarResumoGeral">
    <ng-container *ngFor="let pessoa of listaPessoas; let i = index">
      <div
        class="round mb-2 box-shadow-4"
        [ngClass]="{
          'border-warning': pessoa.statusValidacao === 'pendente' || pessoa.statusValidacao === 'error',
          'border-success': pessoa.statusValidacao === 'successo',
          'border-info': pessoa.statusValidacao === 'enviando',
          'acordeao-destacado': pessoa.destacado
        }">
        <!-- Header do acordeão -->
        <div
          class="card-header round-acord"
          [ngClass]="{
            'bg-warning': pessoa.statusValidacao === 'pendente' || pessoa.statusValidacao === 'error',
            'bg-success': pessoa.statusValidacao === 'successo',
            'bg-info': pessoa.statusValidacao === 'enviando'
          }">
          <h2 class="mb-0">
            <button
              (click)="alternarAcordeao(pessoa.id)"
              class="btn text-white btn-link btn-block text-left d-flex align-items-center justify-content-between"
              type="button"
              [attr.aria-expanded]="pessoa.acordeaoAberto"
              [attr.aria-controls]="'collapsePessoa' + i">
              <div class="d-flex align-items-center flex-wrap">
                <span
                  class="badge f-i mr-2 flex-shrink-0"
                  [ngClass]="{
                    ' text-white': pessoa.tipo === 'titular',
                    ' text-white': pessoa.tipo === 'dependente'
                  }">
                  <i class="fa" [ngClass]="pessoa.tipo === 'titular' ? 'fa-user' : 'fa-child'" aria-hidden="true"></i>
                </span>
                <span
                  class="font-weight-bold d-block d-md-none text-truncate"
                  style="max-width: 200px"
                  [attr.title]="
                    pessoa.tipo === 'titular' ? 'TITULAR' : 'DEPENDENTE' + ' - ' + (pessoa.nome | uppercase)
                  "
                  [attr.data-toggle]="'tooltip'"
                  [attr.data-placement]="'top'">
                  {{ pessoa.tipo === 'titular' ? 'TITULAR' : 'DEPENDENTE' }} - {{ pessoa.nome | uppercase }}
                </span>
                <span class="font-weight-bold d-none d-md-block">
                  {{ pessoa.tipo === 'titular' ? 'TITULAR' : 'DEPENDENTE' }} - {{ pessoa.nome | uppercase }}
                </span>
                <span *ngIf="pessoa.parentesco" class="text-white bold ml-2 flex-shrink-0">
                  <i class="fa fa-circle mr-1"></i>
                  {{ pessoa.parentesco }}
                </span>
              </div>

              <!-- Indicador de status -->
              <span
                class="badge rounded-pill"
                [ngClass]="{
                  'bg-light text-dark': pessoa.statusValidacao === 'pendente' || pessoa.statusValidacao === 'error',
                  'bg-light text-dark': pessoa.statusValidacao === 'successo',
                  'bg-light text-dark': pessoa.statusValidacao === 'enviando'
                }">
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-exclamation-triangle':
                      pessoa.statusValidacao === 'pendente' || pessoa.statusValidacao === 'error',
                    'fa-check-circle': pessoa.statusValidacao === 'successo',
                    'fa-spinner fa-spin': pessoa.statusValidacao === 'enviando'
                  }"></i>
              </span>
            </button>
          </h2>
        </div>

        <!-- Conteúdo do acordeão -->
        <div
          [id]="'collapsePessoa' + i"
          [class.show]="pessoa.acordeaoAberto"
          class="collapse mt-4"
          [attr.data-parent]="'#accordionValidacaoFoto'">
          <div class="card-body">
            <!-- Informações da pessoa -->
            <div class="row mb-3" *ngIf="pessoa.statusValidacao !== 'successo'">
              <div class="col-md-12">
                <h4>
                  <strong>
                    <i class="fa fa-camera"></i>
                    Validação Facial - {{ pessoa.nome }}
                  </strong>
                </h4>
                <p *ngIf="!pessoa.medSeniorCreated" class="text-muted">
                  Olá,
                  <b>{{ pessoa.nome }},</b>
                  precisamos capturar o seu rosto para validação de identidade.
                </p>
              </div>
            </div>

            <!-- Componente de webcam - só mostra se não foi criado no MedSenior -->
            <app-validacao-documento-webcam
              *ngIf="!pessoa.medSeniorCreated"
              #webcamComponent
              (fotoCapturadaEmiter)="onFotoCapturada($event, pessoa.id)"
              (fotoConfirmadaPeloUsuarioEmiter)="cadastrarVida($event, pessoa.id)"
              (cancelled)="onCancelamento(pessoa.id)"></app-validacao-documento-webcam>

            <!-- Mensagem se já foi enviado para MedSenior -->
            <div
              *ngIf="pessoa.medSeniorCreated && pessoa.statusValidacao !== 'successo'"
              class="round alert round text-center alert-info mt-3">
              <span class="text-white bold">
                <i class="fa fa-check-circle mr-2"></i>
                Foto de {{ pessoa.nome }} já enviada para validação.
              </span>
            </div>

            <!-- Mensagem de erro se houver -->
            <div *ngIf="pessoa.statusValidacao === 'error' && pessoa.mensagemErro" class="alert alert-danger mt-3">
              <span class="text-white bold">
                <i class="fa fa-exclamation-circle mr-2"></i>
                {{ pessoa.mensagemErro }}
              </span>
            </div>

            <!-- Mensagem de sucesso individual -->
            <app-status-processing
              *ngIf="pessoa.statusValidacao === 'successo'"
              titulo="Foto Enviada com sucesso!"
              subtitulo="Prossiga para o passo seguinte."></app-status-processing>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- *ngIf="todosComSucesso && !mostrarResumoGeral" -->
  <div class="form-actions mb-1 float-right" style="text-align: right; margin-top: 10px">
    <button (click)="avancarProximoStep()" class="btn round btn-outline-info btn-min-width ng-star-inserted">
      Próximo
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
